import * as r from 'restructure';

// Set of instructions executed whenever the point size or font transformation change
/** @type {import('restructure').Struct} */
export default new r.Struct({
  controlValueProgram: new r.Array(r.uint8)
});
